/**
 * Phase 14.1 — Real carrier logo registry.
 *
 * Maps slug -> public file path under /assets/carriers. Components reference
 * this registry so a single source of truth drives the home CarrierStrip,
 * /carriers/[slug] detail header, and the per-product "Available from" strip.
 *
 * If a file 404s at runtime, the consuming component's <img onError> should
 * fall back to the brand-safe typographic tile. Do NOT embed logos inline —
 * keep them as static assets so CDN caching + disk size stay sane.
 *
 * Sources documented in /app/memory/carrier_logos_sources.md.
 */
export const CARRIER_LOGOS = {
  "allianz":              { src: "/assets/carriers/allianz.svg",               source: "wikipedia" },
  "american-amicable":    { src: "/assets/carriers/american-amicable.png",     source: "carrier-site" },
  "american-equity":      { src: "/assets/carriers/american-equity.svg",       source: "carrier-site" },
  "americo":              { src: "/assets/carriers/americo.png",               source: "carrier-site" },
  "ameritas":             { src: "/assets/carriers/ameritas.png",              source: "carrier-site" },
  "annexus":              { src: "/assets/carriers/annexus.png",               source: "carrier-site" },
  "athene":               { src: "/assets/carriers/athene.svg",                source: "carrier-site" },
  "corebridge-financial": { src: "/assets/carriers/corebridge-financial.svg",  source: "wikipedia" },
  "ethos":                { src: "/assets/carriers/ethos.svg",                 source: "wikipedia" },
  "fg":                   { src: "/assets/carriers/fg.png",                    source: "wikipedia" },
  "lincoln-financial":    { src: "/assets/carriers/lincoln-financial.svg",     source: "carrier-site" },
  "mutual-of-omaha":      { src: "/assets/carriers/mutual-of-omaha.svg",       source: "wikipedia" },
  "nationwide":           { src: "/assets/carriers/nationwide.svg",            source: "wikipedia" },
  "north-american":       { src: "/assets/carriers/north-american.png",        source: "carrier-site" },
};

/** Convenience: boolean check whether we have a real logo for this slug. */
export const hasCarrierLogo = (slug) => Boolean(CARRIER_LOGOS[slug]);

export default CARRIER_LOGOS;
